<div class="form-field">
  @if (props['label']) {
  <label [for]="id" class="form-label">
    {{ props['label'] }}
    @if (props['required']) {
    <span class="required-indicator"> (required)</span>
    }
  </label>
  }

  <div class="duration-input-group">
    <input [id]="id" class="form-input" type="number" [value]="inputValue" [formlyAttributes]="field"
      [placeholder]="(props['placeholder'] || '') | translate" [required]="props['required'] || false"
      [attr.data-testid]="props['attributes']?.['data-testid'] || ('field-' + field.key)" (input)="onInput($event)" />
    <span class="duration-unit">{{ unitSuffix }}</span>
  </div>

  @if (formattedPreview) {
  <div class="form-description">
    {{ 'formBuilder.duration.preview' | translate }} {{ formattedPreview }}
  </div>
  }

  @if (props['description']) {
  <div class="form-description">{{ props['description'] }}</div>
  }

  @if (formControl.touched && formControl.errors) {
  <div class="field-error">
    @if (formControl.errors['required']) {
    <span>{{ 'field.validation.required' | translate }}</span>
    }
  </div>
  }
</div>